import { NgModule } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';

import { ProductsCategoriesRoutingModule } from './products-categories-routing.module';
import { CategoriesListComponent } from './components/categories-list/categories-list.component';
import { CategoryDetailComponent } from './components/category-detail/category-detail.component';
import {SharedModule} from "../shared/shared.module";
import {CategoriesService} from "./services/categories.service";
import {ProductsService} from "./services/products.service";
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import {LightgalleryModule} from "lightgallery/angular";
import {LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule, ScrollHooks} from "ng-lazyload-image";
import {NgxMasonryModule} from "ngx-masonry";
import {DndModule} from "ngx-drag-drop";
import { ProductsAdminComponent } from './components/products-admin/products-admin.component';
import {SwiperModule} from "swiper/angular";
import {NgMagnizoomModule} from "ng-magnizoom";
import { BrowserModule } from '@angular/platform-browser';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { SubCategoriesListComponent } from './components/sub-categories-list/sub-categories-list.component';
import { ProductDialogComponent } from './components/admin/product-dialog/product-dialog.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import { CategoryDialogComponent } from './components/admin/category-dialog/category-dialog.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import { ScreensaverComponent } from './screensaver/screensaver.component';
import { LaterretaSplashscreenComponent } from './components/laterreta-splashscreen/laterreta-splashscreen.component';
import { EventListComponent } from './components/event-list/event-list.component';
import { EventFormComponent } from './components/event-form/event-form.component';
import {MatTabsModule} from "@angular/material/tabs";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatNativeDateModule} from "@angular/material/core";
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import {AppCopyrightComponent} from "../shared/components/app-copyright/app-copyright.component";
import { BarmitierraSplashscreenComponent } from './components/barmitierra-splashscreen/barmitierra-splashscreen.component';
import {FlagsListComponent} from "../core/components/flags-list/flags-list.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'd/m/yyyy', // Format de saisie (jour/mois/année)
  },
  display: {
    dateInput: 'd/m/yyyy', // Format d'affichage (jour/mois/année)
    monthYearLabel: 'mm/yyyy', // Format pour l'étiquette mois/année
    dateA11yLabel: 'LL', // Accessibilité
    monthYearA11yLabel: 'MMMM yyyy', // Accessibilité mois/année
  },
};


@NgModule({
  declarations: [
    CategoriesListComponent,
    CategoryDetailComponent,
    ProductDetailsComponent,
    ProductsAdminComponent,
    SubCategoriesListComponent,
    ProductDialogComponent,
    SplashScreenComponent,
    CategoryDialogComponent,
    ScreensaverComponent,
    LaterretaSplashscreenComponent,
    EventListComponent,
    EventFormComponent,
    AppCopyrightComponent,
    FlagsListComponent,
    BarmitierraSplashscreenComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ProductsCategoriesRoutingModule,
    LightgalleryModule,
    LazyLoadImageModule,
    NgxMasonryModule,
    DndModule,
    SwiperModule,
    NgMagnizoomModule,
    NgxImageZoomModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,

    MatTabsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

  ],
    exports: [
        ProductDetailsComponent,
        SplashScreenComponent,
        ScreensaverComponent,

    ],
  providers: [
    CategoriesService,
    ProductsService,
    DatePipe,
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: ScrollHooks }
  ]
})
export class ProductsCategoriesModule { }
